module.exports = __webpack_public_path__ + "assets/select.d914bfcc2b7f8721bebd09a4c882b5da.png";